export const lineTotalCalc = (minutes, rate) =>
  (Number(minutes / 60) * Number(rate)).toFixed(2);
